import { Link } from "react-router-dom";
import { LEGAL } from "../lib/legal";

/**
 * Slim footer used across Login + dashboards. Keeps the legal links
 * always one click away.
 */
export default function LegalFooter({ className = "" }) {
  return (
    <footer
      className={`border-t border-gray-200 bg-white text-[11px] text-gray-500 ${className}`}
      data-testid="legal-footer"
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex flex-wrap items-center gap-x-5 gap-y-2">
        <span className="font-mono">
          © {new Date().getFullYear()} {LEGAL.company}
        </span>
        <Link
          to="/terms"
          data-testid="footer-terms-link"
          className="hover:text-[#002FA7] hover:underline"
        >
          Terms of Service
        </Link>
        <Link
          to="/privacy"
          data-testid="footer-privacy-link"
          className="hover:text-[#002FA7] hover:underline"
        >
          Privacy Policy
        </Link>
        <a
          href={`mailto:${LEGAL.contactEmail}`}
          className="hover:text-[#002FA7] hover:underline"
        >
          {LEGAL.contactEmail}
        </a>
        <span className="ml-auto text-[10px] uppercase tracking-widest">
          Effective {LEGAL.effectiveDate}
        </span>
      </div>
    </footer>
  );
}
